import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';
const SocialMedia = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage tagName="p" {...messages.socialMediaBody} />
    </ArticleBody>
  </div>
);

SocialMedia.propTypes = {};

export default SocialMedia;
